import { useState, useRef, useEffect } from 'react';
import css from './LineTabs.module.scss';
import PropTypes from 'prop-types';

const LineTabs = ({children, fullWidth = false}) => {
  const [underlineStyle, setUnderlineStyle] = useState({});
  const tabsRef = useRef(null);

  // tabs wrapped in e.g. <FeatureFlag> can change without LineTabs re-rendering
  useEffect(() => {
    const tabs = tabsRef.current;

    const positionUnderline = () => {
      const activeTab = tabs.querySelector(`.${css.active}`);
      if (!activeTab) {
        return;
      }

      const rect = activeTab.getBoundingClientRect();
      const left = rect.left - tabs.getBoundingClientRect().left;

      setUnderlineStyle(previousStyle => {
        if (previousStyle.left === left && previousStyle.width === rect.width) {
          return previousStyle;
        }

        return {left, width: rect.width, transition: 'all 0.2s ease'};
      });
    };
    positionUnderline();

    const mutationObserver = new MutationObserver(positionUnderline);
    mutationObserver.observe(tabs, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
    const resizeObserver = new ResizeObserver(positionUnderline);
    resizeObserver.observe(tabs);

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className={`${css.tabsWrapper} ${fullWidth ? css.fullWidth : ''}`}>
      <div className={css.tabs} ref={tabsRef}>
        {children}
      </div>
      <div className={css.underline} style={underlineStyle} />
    </div>
  );
};

LineTabs.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool
};

export default LineTabs;
